import bizCorp from 'assets/images/icons/biz-corporation.svg';
import bizSole from 'assets/images/icons/biz-sole.svg';
import bizIndividual from 'assets/images/icons/biz-individual.svg';
import bizGovernment from 'assets/images/icons/biz-partnership.svg';

export const GENERAL_INFO = 'ONBOARDING/general_info';
export const BUSINESS_INFO = 'ONBOARDING/business_info';
export const APPLICATION = 'ONBOARDING/application';

export const CHECK_SAVED_BUSINESS_INFO = 'ONBOARDING/check_saved_business_info';

export const BUSINESS_TYPES = [
  {
    code: 'CORPORATION',
    name: 'Corporation',
    description:
      'Your business is owned by a corporate entity and registered with ROC Brunei',
    icon: bizCorp,
  },
  {
    code: 'SOLE_PROPRIETORSHIP',
    name: 'Sole proprietorship/Partnership',
    description:
      'You are the sole owner of a business or your Business is owned by a corporate entity and registered with ROC Brunei',
    icon: bizSole,
  },
  {
    code: 'INDIVIDUAL',
    name: 'Individual',
    description:
      'You are the only owner of a business, and you are not registered with ROC Brunei',
    icon: bizIndividual,
  },
  {
    code: 'GOVERNMENT',
    name: 'Government',
    description: 'Government Entity or Government Agency',
    icon: bizGovernment,
  },
];
